// 세금계산서 상세 정보 컴포넌트

import { useLanguage } from '@/contexts/AppContext';
import { DEFAULT_STORE_TIMEZONE } from '@/utils/menuAvailability';
import type { InvoiceData, InvoiceTranslations } from './types';

interface InvoiceDetailsProps {
  invoiceData: InvoiceData;
  translations: InvoiceTranslations;
}

export function InvoiceDetails({ invoiceData, translations }: InvoiceDetailsProps) {
  const { language } = useLanguage();
  // #1816: 세금계산서(법적 산출물) 시각도 매장 타임존(멕시코)으로 고정.
  const formatDateTime = (date: Date) => {
    return new Intl.DateTimeFormat(
      language === 'ko' ? 'ko-KR' : language === 'es' ? 'es-MX' : 'en-US',
      {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: DEFAULT_STORE_TIMEZONE
      }
    ).format(date);
  };

  return (
    <div className="bg-muted rounded-lg p-4 space-y-3">
      <div className="flex justify-between text-sm">
        <span className="text-muted-foreground">{translations.invoiceNumber}</span>
        <span className="font-mono font-medium text-foreground">
          {invoiceData.folio}
        </span>
      </div>
      <div className="flex justify-between text-sm">
        <span className="text-muted-foreground">{translations.uuid}</span>
        <span className="font-mono font-medium text-xs break-all text-foreground">
          {invoiceData.uuid}
        </span>
      </div>
      <div className="flex justify-between text-sm">
        <span className="text-muted-foreground">{translations.company}</span>
        <span className="font-medium text-right text-foreground">
          {invoiceData.company.name}
        </span>
      </div>
      <div className="flex justify-between text-sm">
        <span className="text-muted-foreground">{translations.generatedAt}</span>
        <span className="font-medium text-foreground">
          {formatDateTime(invoiceData.timestamp)}
        </span>
      </div>
    </div>
  );
}
